// This section name, must match the name coming from partner-orchestrator
export const PARTNER_PROFILE_SECTION_NAME = 'Partner Profile';

export const PARTNER_PROFILE_EDIT_HISTORY_HIDDEN_ATTRIBUTES = [
  'personalBackground.hobbiesAndInterests',
  'HobbyOrInterest/id',
  'Licence/id',
  'TaxResidence/id',
  'TaxResidence/techId',
  'businessBackground/endClient.overallAumCurrency',
  'businessBackground/endClient/shareOfWallet/0.id',
  'licences',
  'personalBackground/criminalRecord.docStoreId',
  'taxInformation.taxResidences',
  'VisitVisitDetailsInner/id',
  'entityStructureBackground/operatingCompany/rmCompanyVisit.visitDetails',
  'taxInformation/legalPartnerFatca.crsEntityClassification',
  'taxInformation/legalPartnerFatca.fatcaLegalEntityType',
  'Evidence/id',
  'evidenceDocument.agreementId',
  'ProductConfig/active',
  'ProductConfig/code',
  'ProductConfig/id',
  'businessBackground.finServicesViaGrpMembers',
  'businessBackground.productOfferings',
  'businessBackground/endClient/clientBreakdownAccountSize/0.accountSizeSegment',
  'businessBackground/endClient/clientBreakdownAccountSize/0.id',
  'businessBackground/endClient/clientBreakdownAccountSize/1.accountSizeSegment',
  'businessBackground/endClient/clientBreakdownAccountSize/1.id',
  'businessBackground/endClient/clientBreakdownAccountSize/3.accountSizeSegment',
  'businessBackground/endClient/clientBreakdownAccountSize/3.id',
  'businessBackground/endClient/clientBreakdownAccountSize/2.accountSizeSegment',
  'businessBackground/endClient/clientBreakdownAccountSize/2.id',
  'businessBackground/endClient/clientDomiciles/0.id',
  'personalBackground/criminalRecord.version',
  'taxInformation.partnerUId',
  'personalBackground/familyBackground.supportingDocuments',
  'partnerClassification/industries/nogaCode.key',
  'partnerClassification/industries/snbBranchCode.key',
  'partnerClassification/industries/snbCustomerCategory.key',
];
